(function () {
  function slugify(text) {
    return text.trim()
      .toLowerCase()
      .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '')
      .substring(0, 60);
  }

  function buildToc(container) {
    var tocList = container.querySelector('.js-toc-list');
    if (!tocList) return;

    var depth = parseInt(container.dataset.depth, 10) || 2;
    var highlight = container.dataset.highlight === 'true';
    var selector = depth >= 3 ? 'h2, h3' : 'h2';

    var all = Array.from(document.querySelectorAll('main ' + selector));
    var headings = all.filter(function (h) {
      return !h.closest('.article-sidebar-section') && !h.closest('.toc-section');
    });

    if (headings.length === 0) {
      tocList.innerHTML = '<li class="toc__empty">Keine Überschriften gefunden.</li>';
      return;
    }

    headings.forEach(function (h, i) {
      if (!h.id) h.id = 'toc-h-' + i + '-' + slugify(h.textContent);
    });

    tocList.innerHTML = headings.map(function (h) {
      var sub = h.tagName === 'H3' ? ' toc__item--sub' : '';
      return '<li class="toc__item' + sub + '"><a class="toc__link" href="#' + h.id + '">'
        + h.textContent.trim() + '</a></li>';
    }).join('');

    if (!highlight) return;

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var link = tocList.querySelector('a[href="#' + e.target.id + '"]');
        if (!link) return;
        if (e.isIntersecting) {
          tocList.querySelectorAll('.toc__link--active').forEach(function (l) {
            l.classList.remove('toc__link--active');
          });
          link.classList.add('toc__link--active');
        }
      });
    }, { rootMargin: '-10% 0px -80% 0px' });

    headings.forEach(function (h) { obs.observe(h); });
  }

  function initAll() {
    document.querySelectorAll('.toc-section[data-depth]').forEach(buildToc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function () {
    setTimeout(initAll, 50);
  });
})();
